export default __webpack_public_path__ + "static/media/system-update-settings.4cae208d.svg";